import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { QualifierValue } from "../../internal/qualifier/QualifierValue.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
/**
 * @description A class that defines how to remove the background of an asset
 * @extends SDK.Action
 * @memberOf Actions.Effect
 * @see Visit {@link Actions.Effect|Effect} for an example
 */

var RemoveBackgroundAction = /*#__PURE__*/function (_Action) {
  _inherits(RemoveBackgroundAction, _Action);

  var _super = _createSuper(RemoveBackgroundAction);

  function RemoveBackgroundAction() {
    var _this;

    _classCallCheck(this, RemoveBackgroundAction);

    _this = _super.call(this);

    _this.overwriteQualifier();

    return _this;
  }
  /**
   * @description Everytime this method is called, it will overwrite the e_bgremoval qualifier with new values
   * @private
   */


  _createClass(RemoveBackgroundAction, [{
    key: "overwriteQualifier",
    value: function overwriteQualifier() {
      var value = ['bgremoval', this._screen ? 'screen' : '', (this._colorToRemove || '').replace('#', '')];
      return this.addQualifier(new Qualifier('e', new QualifierValue(value)));
    }
    /**
     * @description The strength of the shadow. (Range: 0 to 100, Server default: 40)
     * @param {number} useScreen Boolean, defaults to true
     * @return {this}
     */

  }, {
    key: "screen",
    value: function screen() {
      var useScreen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      this._screen = useScreen;
      return this.overwriteQualifier();
    }
    /**
     * @description The color to remove from the background
     * @param {SystemColors} color
     * @return {this}
     */

  }, {
    key: "colorToRemove",
    value: function colorToRemove(color) {
      this._colorToRemove = color;
      return this.overwriteQualifier();
    }
  }]);

  return RemoveBackgroundAction;
}(Action);

export { RemoveBackgroundAction };